import React, { useReducer } from 'react';
import { initialState, AuthReducer } from './reducer';
import PropTypes from 'prop-types';

const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();

// create custom hooks that will help us read values from these context objects without having to call React.useContext 
// in every component that needs that context value and 
// it also does some error handling in case these contexts are used outside the context providers.
export function useAuthState() {
	const context = React.useContext(AuthStateContext);
	if (context === undefined) {
		throw new Error('useAuthState must be used within a AuthProvider');
	}

	return context;
}

export function useAuthDispatch() {
	const context = React.useContext(AuthDispatchContext);
	if (context === undefined) {
		throw new Error('useAuthDispatch must be used within a AuthProvider');
	}

	return context;
}

export const AuthProvider = ({ children }) => {
	const [state, dispatch] = useReducer(AuthReducer, initialState);

	return (
		<AuthStateContext.Provider value={state}>
			<AuthDispatchContext.Provider value={dispatch}>
				{children}
			</AuthDispatchContext.Provider>
		</AuthStateContext.Provider>
	);
};

AuthProvider.propTypes = {
	children: PropTypes.node.isRequired,
};